

















import Vue from "vue";
import MyHeader from "@/components/BasicLayout/Header.vue";
import MyMenu from "@/components/BasicLayout/Menu.vue";
import MyBread from "@/components/BasicLayout/Bread.vue";
export default Vue.extend({
  name: "BasicLayout",
  components: { MyHeader, MyMenu, MyBread },
  data() {
    return {
      isCollapsed: false
    };
  }
});
